// =======================================
// SYNC WITH ADMIN/PARTIALS/CURRENCY-FIELD
// =======================================

import React from "react";
import { TextField } from "material-ui";

import { formatPrice } from "../../util";

/**
 * Display currency input fields in a user-friendly $xx.yy format, but serialize them
 * into cents before propagating to the parent component. A thin wrapper around
 * material-ui's <TextField/>.
 */
class CurrencyField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editedValue: null
    };

    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
  }

  focus() {
    this.field && this.field.focus();
  }

  _handleInputChange(e) {
    let { value } = e.target;

    this.setState({
      editedValue: value
    });

    this.props.onChange({
      target: {
        value: value.replace(/[^0-9\.]/g, "") * 100 || 0
      }
    });
  }

  _handleInputBlur() {
    this.setState({ editedValue: null });
  }

  render() {
    let { value, onChange, onBlur, placeholder, ...props } = this.props,
      { editedValue } = this.state;

    if (placeholder === "$0.00") {
      placeholder = formatPrice(0);
    }

    return (
      <TextField
        ref={r => {
          this.field = r;
        }}
        name="currency"
        value={
          editedValue !== null
            ? editedValue
            : value
            ? `${formatPrice(value)}`
            : ""
        }
        onChange={this._handleInputChange}
        onBlur={this._handleInputBlur}
        placeholder={placeholder}
        {...props}
      />
    );
  }
}

export default CurrencyField;



// WEBPACK FOOTER //
// ./src/app/components/partials/currency-field.jsx